/** @jsxImportSource theme-ui @jsxRuntime classic */
import { AnchorSection, Box } from '@tishman/components';
import React from 'react';

import { THEME_ORDER } from '../common/themeOrder';

import { BuyTicketsCarousel } from './BuyTicketsCarousel';

import type { BuyTicketsProps } from '../types';

export function BuyTicketsDesktop({
  categories,
}: BuyTicketsProps): React.JSX.Element {
  return (
    <Box
      data-section="BuyTicketsDesktop"
      sx={{
        '& > :first-of-type > *': {
          pt: '0px',
        },
        'width': '100%',
        'maxWidth': '100%',
      }}
    >
      {categories.map((category, i) => (
        <AnchorSection
          id={`${category.slug?.current}`}
          key={category.id}
          sx={{
            py: '71px',
            px: [3, 4],
            display: ['none', 'flex'],
            width: '100%',
            maxWidth: '100%',
          }}
          theme={THEME_ORDER[i] || 'Rock Center Black'}
        >
          <BuyTicketsCarousel
            categories={categories}
            category={category as Queries.SanityTicketCategory}
            key={category.id}
          />
        </AnchorSection>
      ))}
    </Box>
  );
}
